export const getUserData = (state) => state.profileSlice?.userData;

export const getUserIsAuth = (state) => state.authorizationsSlice?.isAuth;

export const getAdminUserData = (state) => state.authorizationsSlice?.adminUser;
